<template>
  <v-card tile>
    <v-toolbar flat>
      <v-btn v-if="back" large text icon rounded small color="primary" class="back-button" @click="$router.back()"><v-icon>arrow_back</v-icon></v-btn>
      <v-icon large>{{icon}}</v-icon>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer />
      <slot name="toolbar" />
    </v-toolbar>
    <v-banner single-line>
      <v-avatar slot="icon" color="green lighten-5" size="30">
        <v-icon icon="mdi-information-outline" color="green darken-3" size="20">mdi-information-outline</v-icon>
      </v-avatar>
      {{description}}
    </v-banner>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    back: {
      type: Boolean,
      default: false
    },
    icon: {
      type:String,
      default:""
    }
  }
}
</script>

<style lang="scss" scoped>
.back-button {
  margin-left: -4px !important;
  margin-right: 4px;
}
</style>